export default __webpack_public_path__ + "static/img-app-deployment-b4bde93f97d742699cfe074c2af25988.webp";